module.exports = __webpack_public_path__ + "img/54.ce70fa40.jpg";